// js
import React from 'react';
import PropTypes from 'prop-types';
// css
import '../../styles/components/common/Checkbox.scss';


function Checkbox({name, checked, label, handleChange, activeClass, inactiveClass}) {

  return (
    <div className='checkbox'>
      <label>
        <input type='checkbox' name={name} checked={checked} onChange={handleChange} />
        <i className={`icon ${checked ? activeClass : inactiveClass}`} />
        {label}
      </label>
    </div>
  );
}

Checkbox.defaultProps = {
  activeClass: 'icon-checkmark-active',
  inactiveClass: 'icon-checkmark-inactive'
};

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  activeClass: PropTypes.string,
  inactiveClass: PropTypes.string,
  label: PropTypes.string
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/common/Checkbox.js